var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCountryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_51_201",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 36
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "matrix(1 0 0 -1 0 35.5)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_51_201)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.6679,
    height: 35.0036,
    transform: "matrix(1 0 0 -1 0 35.3542)",
    fill: "#008850"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.6679,
    height: 35.0036,
    transform: "matrix(1 0 0 -1 11.6611 35.3542)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.6679,
    height: 35.0036,
    transform: "matrix(1 0 0 -1 23.3276 35.3542)",
    fill: "#008850"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryIcon);
export default __webpack_public_path__ + "static/media/country-icon.009cb653dfd6a4a4ce8a6d2916339329.svg";
export { ForwardRef as ReactComponent };